'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'pen-ruler';
var width = 512;
var height = 512;
var aliases = ["pencil-ruler"];
var unicode = 'f5ae';
var svgPathData = ['M16.3 485.9c-.8 2.8 0 5.8 2.1 7.8s5 2.8 7.8 2.1l127.8-35.5c12-3.3 22.9-9.7 31.6-18.5L404 223.3 288.7 108 70.2 326.4c-8.8 8.8-15.1 19.7-18.5 31.6L16.3 485.9z', 'M364.2 32.5C374.8 21.9 389.1 16 404 16s29.2 5.9 39.8 16.5l35.7 35.7C490.1 78.8 496 93.1 496 108s-5.9 29.2-16.5 39.8L415.3 212 300 96.7 364.2 32.5zM288.7 108L404 223.3 185.6 441.8c-8.8 8.8-19.7 15.1-31.6 18.5L26.1 495.7c-2.8 .8-5.8 0-7.8-2.1s-2.8-5-2.1-7.8L51.8 358.1c3.3-12 9.7-22.9 18.5-31.6L288.7 108zM404 0c-19.2 0-37.6 7.6-51.1 21.2l-294 294c-10.7 10.7-18.5 24.1-22.6 38.7L.9 481.6c-2.3 8.3 0 17.3 6.2 23.4s15.1 8.5 23.4 6.2l127.8-35.5c14.6-4.1 27.9-11.8 38.7-22.6l294-294C504.4 145.6 512 127.2 512 108s-7.6-37.6-21.2-51.1L455.1 21.2C441.6 7.6 423.2 0 404 0zM367 489l-69.1-69.1-11.3 11.3 69.1 69.1c15.6 15.6 40.9 15.6 56.6 0l88-88c15.6-15.6 15.6-40.9 0-56.6l-69.1-69.1-11.3 11.3 19.4 19.4-53 53c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l53-53 38.3 38.3c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0zM92.1 214.1L23 145c-9.4-9.4-9.4-24.6 0-33.9l88-88c9.4-9.4 24.6-9.4 33.9 0l38.3 38.3-53 53c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l53-53 19.4 19.4 11.3-11.3-69.1-69.1c-15.6-15.6-40.9-15.6-56.6 0l-88 88c-15.6 15.6-15.6 40.9 0 56.6l69.1 69.1 11.3-11.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenRuler = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;